/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import UARangePicker from '../UARangePicker';
import { customEndAdornmentMultiRangePicker, customHeaderMultiRangePicker } from './utils';

const useStyles = makeStyles((theme) => ({
    datepickerCustomHeader: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        paddingTop: '1rem',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        paddingBottom: '10px',
        display: 'block',
        // justifyContent: 'space-between',
        // alignItems: 'center',
        '@media (max-width:600px)': {
            flexDirection: 'column',
        },
    },
    textInput: {
        height: '2rem',
        width: '100%',
        '& .MuiInputBase-root': {
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '@media (max-width:1100px)': {
            marginBottom: '20px !important',
        },
        '& .MuiSelect-select': {
            borderRadius: '4px',
            paddingRight: '31px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '& .MuiSelect-selectMenu svg': {
            display: 'none',
        },
        '@media (max-width:600px)': {
            width: '100%',
            marginBottom: '8px',
        },
    },
    valueWithChip: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    chip: {
        color: '#3F5E20 !important',
        height: '22px',
        width: '100%',
        display: 'block',
        boxShadow: 'none',
        zIndex: '99',
        background: 'none',
        textAlign: 'end',
        '& .MuiChip-label': {
            padding: 0,
            display: 'none',
        },
        '& .MuiChip-icon': {
            color: '#3F5E20 !important',
        },
    },
    doubleCarretIcon: {
        marginRight: '0.7rem',
    },
    clearButton: {
        // backgroundColor: theme.palette.text.mainGreen,
        // color: theme.palette.text.primary,
        // height: '2rem',
        // border: 'none',
        // margin: 'unset',
        // borderRadius: '3px',
        // lineHeight: '12px',
        // '&:hover': {
        //     backgroundColor: theme.palette.text.mainGreen,
        // },
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '0.75rem',
        lineHeight: '133%',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        border: 'none',
        background: 'none',
        padding: '0',
        color: '#3F5E20',
        float: 'right',
        marginTop: 15,
        height: 15,
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D !important',
            borderRadius: '3px',
        },
        '& .MuiButton-contained:hover': {
            background: 'none !important',
        },
        '&:hover': {
            backgroundColor: '#fff',
            color: '#3F5E20',
            border: 'none',
        },
        '@media (max-width:600px)': {
            width: '100%',
        },
    },
    selectedDate: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& svg': {
            paddingLeft: '10px',
        },
    },
    dateOption: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    selectDateType: {
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '160%',
        letterSpacing: '0.4px',
        color: '#586071',
    },
    selectDateTypeError: {
        color: '#BE0921',
    },
    inputError: {
        border: '1px solid #BE0921',
    },
    rdrMonthsHorizontal: {
        '@media (max-width:600px)': {
            flexDirection: 'column',
        },
    },
}));

const UAMultiRangePicker = ({ dropdownOptions = [], onUpdateRanges, id, className, ranges = [], onClose }) => {
    const classes = useStyles();
    const [dateType, setDateType] = useState(dropdownOptions && dropdownOptions[0]);

    const [selectedRange, setSelectedRange] = useState(null);
    const [dataTypeNotSelected, setDataTypeNotSelected] = useState(false);
    const [appliedRanges, setAppliedRanges] = useState([]);
    const [headerIsOpen, setHeaderIsOpen] = useState(false);

    const handleDropdownChange = (event) => {
        const dateTypeLabel = dropdownOptions.find((option) => option.key === event.target.value);
        const existingRange = ranges.find((dt) => dt.dateType === event.target.value);
        if (!existingRange) {
            const now = new Date();
            const newSelectedRange = { startDate: now, endDate: now };
            onUpdateRanges([...ranges, { dateType: event.target.value, dateTypeLabel: !!dateTypeLabel && dateTypeLabel.label, ...newSelectedRange }]);
            setSelectedRange(newSelectedRange);
        } else {
            setSelectedRange(existingRange);
        }
        setDateType(event.target.value);
    };

    const applyRequest = () => {
        setAppliedRanges([...ranges]);
    };

    const cancelRequest = () => {
        // select the first selected Date if exists
        if (!!appliedRanges.length) {
            onUpdateRanges(appliedRanges);
            setDateType(appliedRanges.length > 1 && appliedRanges[0].dateType === '' ? appliedRanges[1].dateType : appliedRanges[0].dateType);
        } else {
            onUpdateRanges([{ dateType: '', dateTypeLabel: '' }]);
            const now = new Date();
            const newSelectedRange = { startDate: now, endDate: now };
            setSelectedRange(newSelectedRange);
            setDateType('');
        }
    };

    const handleUpdateRanges = (updatedRange) => {
        const dateRangeIdx = ranges.findIndex((dr) => dr.dateType === dateType);
        const updatedDateRanges = [...ranges];
        updatedDateRanges[dateRangeIdx] = { ...updatedDateRanges[dateRangeIdx], ...updatedRange };
        onUpdateRanges(updatedDateRanges);
    };

    const onCloseCalendar = (event) => {
        onClose(event);
    };

    const clearSelectedDate = () => {
        //remove dateType from selected dates object
        const newRanges = ranges.filter((range) => range.dateType && range.dateType !== dateType);

        // select the first selected Date if exists
        if (!!newRanges.length) {
            onUpdateRanges(newRanges);
            setDateType(newRanges[0].dateType);
        } else {
            onUpdateRanges([{ dateType: '', dateTypeLabel: '' }]);
            const now = new Date();
            const newSelectedRange = { startDate: now, endDate: now };
            setSelectedRange(newSelectedRange);
            setDateType('');
        }
    };

    useEffect(() => {
        if (!ranges) {
            onUpdateRanges([{ dateType: '', dateTypeLabel: '' }]);
        } else if (ranges.length === 1 && !(ranges[0].startDate || ranges[0].endDate)) {
            const now = new Date();
            setSelectedRange({ startDate: now, endDate: now });
            setDateType(ranges[0].dateType);
        } else {
            const selectedDateRange = ranges.find((dr) => dr.dateType === dateType);
            if (selectedDateRange) {
                const { _dateType, ...restRange } = selectedDateRange;
                setSelectedRange(restRange);
            }
        }
    }, [ranges, dateType, onUpdateRanges]);

    const customHeader = customHeaderMultiRangePicker({
        classes,
        handleDropdownChange,
        dateType,
        dropdownOptions,
        ranges,
        clearSelectedDate,
        setDataTypeNotSelected,
        dataTypeNotSelected,
        headerIsOpen,
        setHeaderIsOpen,
    });

    const customEndAdornment = customEndAdornmentMultiRangePicker({ ranges, classes });

    return (
        <div className={`${className}`}>
            <UARangePicker
                id={id}
                customHeader={customHeader}
                customInputEndAdornment={customEndAdornment}
                onUpdateRanges={handleUpdateRanges}
                range={selectedRange}
                onClose={onCloseCalendar}
                ranges={ranges}
                dataTypeNotSelected={dataTypeNotSelected}
                setDataTypeNotSelected={setDataTypeNotSelected}
                cancelRequest={cancelRequest}
                applyRequest={applyRequest}
            />
        </div>
    );
};

export default UAMultiRangePicker;
